import React, { ReactNode } from 'react';
import Text from '../Text';
import './IconText.less';

export type IconTextProps = {
  type?: 'primary' | 'link' | 'default';
  textSize?: 1 | 2 | 3 | 4;
  htmlType?: 'submit' | 'reset' | 'button';
  background?: boolean;
  placement?: 'left' | 'right';
  rows?: 1 | 2 | 3 | null;
  bold?: boolean;
  semiBold?: boolean;
  textColor?:
    | 'dark-100'
    | 'dark-50'
    | 'dark-30'
    | 'dark-20'
    | 'dark-10'
    | 'indicator-good'
    | 'indicator-caution'
    | 'indicator-bad'
    | 'indicator-neutral';
  icon?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const TIconText: React.FC<IconTextProps> = ({
  textSize = 1,
  type = 'primary',
  htmlType = 'submit',
  placement = 'left',
  onClick,
  background,
  icon,
  rows,
  bold = false,
  semiBold = false,
  textColor = 'dark-100',
  ...props
}) => {
  const classNames = ['t-icon-text'];
  if (!!background) {
    classNames.push('t-icon-background');
  }
  if (!!textSize) {
    classNames.push(`t-icon-text-${textSize}`);
  }
  return (
    <div className={classNames.join(' ')} onClick={onClick}>
      {placement === 'left' && <span className="t-icon-left">{icon}</span>}
      <Text
        bold={bold}
        semiBold={semiBold}
        rows={rows}
        textColor={textColor}
        level={textSize}
      >
        {props.children}
      </Text>
      {placement === 'right' && <span className="t-icon-right">{icon}</span>}
    </div>
  );
};

export default TIconText;
